"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var FileUploadChange = /** @class */ (function () {
    function FileUploadChange() {
        var _a;
        this.fileUploads = document.querySelectorAll("[".concat(constants_1.DATA_FILEUPLOAD_INPUT, "]"));
        if (!this.fileUploads) {
            return;
        }
        (_a = this.fileUploads) === null || _a === void 0 ? void 0 : _a.forEach(function (input) {
            var fileChosenInitText = input.closest("[".concat(constants_1.DATA_FILEUPLOAD_WRAP, "]")).querySelector("[".concat(constants_1.DATA_FILEUPLOAD_CHOSEN_FILE, "]")).textContent;
            var fileChosen = input.closest("[".concat(constants_1.DATA_FILEUPLOAD_WRAP, "]")).querySelector("[".concat(constants_1.DATA_FILEUPLOAD_CHOSEN_FILE, "]"));
            input.addEventListener('change', function () {
                if (input.files.length === 0) {
                    fileChosen.textContent = fileChosenInitText;
                }
                else {
                    fileChosen.textContent = input.files[0].name;
                }
            });
        });
    }
    return FileUploadChange;
}());
exports.default = FileUploadChange;
